import { Card } from '@instabox/consumer-web-ui'
import { motion } from 'framer-motion'

const AnimatedCard = motion(Card)

export default AnimatedCard
